import { Users, Star, Headphones, Globe } from "lucide-react";

const stats = [
  { icon: Users, value: "5,000+", label: "Happy Travelers" },
  { icon: Star, value: "4.9 / 5", label: "Average Rating" },
  { icon: Headphones, value: "24 / 7", label: "Expert Support" },
  { icon: Globe, value: "100+", label: "Destinations" },
];

export const TrustStrip = () => {
  return (
    <section className="bg-surface-subtle border-b border-border py-8" data-testid="trust-strip">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {stats.map((stat, i) => (
            <div
              key={i}
              className="flex items-center gap-3.5"
              data-testid={`trust-item-${i}`}
            >
              <div className="h-10 w-10 rounded-xl bg-white shadow-sm flex items-center justify-center shrink-0">
                <stat.icon className="h-5 w-5 text-accent" />
              </div>
              <div>
                <p className="text-base font-bold text-primary leading-none">{stat.value}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
